// dependencies
import React from "react";
import { StyleSheet, ViewStyle } from "react-native";

// hocs
import withMedia from "../../hocs/withMedia";

// components
import { Row, Col } from "../Grid";
import PlaceholderView from "../PlaceholderView";

type IProps = {
  matches?: boolean;
};

type IState = {};

class RateListPlaceholder extends React.Component<IProps, IState> {
  public static defaultProps: Partial<IProps>;

  private getStyles(): StyleSheet.NamedStyles<{
    rate: ViewStyle;
  }> {
    const { matches } = this.props;

    return StyleSheet.create({
      rate: {
        width: "100%",
        height: matches ? "2.5em" : "1.5em",
      },
    });
  }

  public render(): JSX.Element {
    const { matches } = this.props;

    const styles = this.getStyles();

    return (
      <Row
        breakpointList={{ all: Infinity }}
        col={{ all: matches ? 4 : 1 }}
        gutter={matches ? 0.625 : 0.125}
      >
        <Col>
          <PlaceholderView style={styles.rate} />
        </Col>

        <Col>
          <PlaceholderView style={styles.rate} />
        </Col>

        <Col>
          <PlaceholderView style={styles.rate} />
        </Col>

        <Col>
          <PlaceholderView style={styles.rate} />
        </Col>
      </Row>
    );
  }
}

export default withMedia({
  query: { minWidth: 490 },
  breakpointType: "element",
})(RateListPlaceholder);
